import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  TextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface FormPreviewModalProps {
  open: boolean;
  onClose: () => void;
  leadsFormItems: any[];
}

const FormPreviewModal: React.FC<FormPreviewModalProps> = ({ open, onClose, leadsFormItems }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Form Preview
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {leadsFormItems?.length === 0 ? (
          <Typography>No fields to preview.</Typography>
        ) : (
          <Grid container spacing={2}>
            {leadsFormItems?.map((item, index) => (
              <Grid item xs={12} key={index}>
                <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                  {item?.alias_name || item?.key_name} ({item?.key_type})
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  disabled
                  placeholder={`Example: ${item?.key_type?.toLowerCase()} input`}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FormPreviewModal;
